export enum ProfileUserDataTabs {
  Chains = 'chains',
  Bridges = 'bridges',
  DEXes = 'dexes',
  Campaigns = 'campaigns',
}
